import { useEffect, useState, useCallback } from "react";
import { getComplementMDM, getFullComplementMDM } from "../../service/complementMDM.service";

export const useComplementMDM = ({ id_documento }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchComplement = useCallback(async () => {
    try {
      if (!id_documento) return;

      setLoading(true);
      setError(null);

      const result = await getComplementMDM(id_documento);
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [id_documento]);

  useEffect(() => {
    fetchComplement();
  }, [fetchComplement]);

  return {
    data,
    loading,
    error,
    refetch: fetchComplement,
  };
};

export const useFullComplementMDM = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFullComplement = useCallback(async () => {
    try {

      setLoading(true);
      setError(null);

      const result = await getFullComplementMDM();
      if (process.env.REACT_APP_IS_PREVIEW === 'true') {
        setData(result.data);
      } else {
        setData(result);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFullComplement();
  }, [fetchFullComplement]);

  return {
    data,
    loading,
    error,
    refetch: fetchFullComplement,
  };
};
